/* eslint-disable max-len */
import _ from 'lodash';

// eslint-disable-next-line import/prefer-default-export
export function isNotEmptyOrZero(amount) {
    return !_.isEmpty(amount)
            && amount.amount !== null
            && amount.amount != 0;
}